import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LoginComponent } from '../shared/login/login.component';
import { ResetPasswordComponent } from '../shared/reset-password/reset-password.component';
import { OemSignupComponent } from '../shared/oem-signup/oem-signup.component';
import { DistributorSignupComponent } from '../shared/distributor-signup/distributor-signup.component';
import { ForgotPasswordComponent } from '../shared/forgot-password/forgot-password.component';
import { SignupComponent } from '../shared/signup/signup.component';
import { EndCustomerSignupComponent } from '../shared/end-customer-signup/end-customer-signup.component';
import { TermsandconditionsComponent } from '../shared/termsandconditions/termsandconditions.component';
import { PrivacypolicyComponent } from '../shared/privacypolicy/privacypolicy.component';
import { CategoryDeatilsComponent } from '../shared/category-deatils/category-deatils.component';
import { ProductPageComponent } from '../shared/product-page/product-page.component';
import { LandingpageComponent } from '../shared/landingpage/landingpage.component';
import { BrandComponent } from '../shared/brand/brand.component';
import { CareersComponent } from '../shared/careers/careers.component';
import { JobDetailsComponent } from '../shared/careers/job-details/job-details.component';
import { ViewAllJobsComponent } from '../shared/careers/view-all-jobs/view-all-jobs.component';
import { JobApplyComponent } from '../shared/careers/job-apply/job-apply.component';
import { BrandProfileComponent } from '../shared/brand-profile/brand-profile.component';
import { WebinarComponent } from '../shared/website/webinar/webinar.component';
import { WebinarViewComponent } from '../shared/website/webinar-view/webinar-view.component';
import { ProductEnquiryDistributorsComponent } from '../end-customer/product-enquiry-distributors/product-enquiry-distributors.component';
import { authGuard } from 'src/app/guards/auth.guard';
import { ProductDistributionRequestComponent } from '../shared/product-distribution-request/product-distribution-request.component';
import { HospitalsComponent } from '../shared/hospitals/hospitals.component';
import { HospitalPortfolioComponent } from '../shared/hospitals/hospital-portfolio/hospital-portfolio.component';
import { HowDoesItWorksComponent } from '../shared/how-does-it-works/how-does-it-works.component';
import { HospitalDetailsComponent } from '../shared/hospital-details/hospital-details.component';
import { DocterInfoComponent } from '../shared/docter-info/docter-info.component';
import { NewsandTrendsComponent } from '../shared/newsand-trends/newsand-trends.component';
import { UnderDevelopmentComponent } from '../shared/under-development/under-development.component';
import { LabInfoComponent } from '../shared/lab-info/lab-info.component';
import { ClinicDetailsComponent } from '../shared/clinic-details/clinic-details.component';
import { HealthcareServicesComponent } from '../shared/healthcare-services/healthcare-services.component';
import { EndCustomerComponent } from '../end-customer/end-customer.component';
import { KnowledgeCenterComponent } from '../shared/knowledge-center/knowledge-center.component';
import { HomeProductViewComponent } from '../shared/home-product-view/home-product-view.component';
import { NewsAndInsightsComponent } from '../shared/news-and-insights/news-and-insights.component';
import { ProductsSearchLandingPageComponent } from '../shared/products-search-landing-page/products-search-landing-page.component';
import { WebsiteDistributorComponent } from '../shared/website-distributor/website-distributor.component';
import { RefundPolicyComponent } from '../shared/refund-policy/refund-policy.component';

const routes: Routes = [
  {
    path: '',
    component: LandingpageComponent
  },
  {
    path: 'signup',
    component: SignupComponent
  },
  {
    path: 'admin-login',
    component: LoginComponent
  },
  {
    path: 'login',
    component: LoginComponent
  },
  {
    path: 'user/forgot-password',
    component: ForgotPasswordComponent
  },
  {
    path: 'reset-password',
    component: ResetPasswordComponent
  },
  {
    path: 'oem/signup',
    component: OemSignupComponent
  },
  {
    path: 'distributor/signup',
    component: DistributorSignupComponent
  },
  {
    path: 'user/signup',
    component: EndCustomerSignupComponent
  },
  {
    path: 'terms-and-conditions',
    component: TermsandconditionsComponent
  },
  {
    path: 'privacy-policy',
    component: PrivacypolicyComponent
  },
  {
    path: 'refund-policy',
    component: RefundPolicyComponent
  },
  {
    path: 'how-it-work',
    component: HowDoesItWorksComponent
  },
  {
    path: 'category/:id',
    component: CategoryDeatilsComponent
  },
  {
    path: 'product-details/:id',
    component: ProductPageComponent
  },
  {
    path: 'brands',
    component: BrandComponent
  },
  {
    path:'website-distributor',
    component: WebsiteDistributorComponent
  },
  {
    path: 'jobs',
    component: CareersComponent,
    // canActivate: [authGuard], data: { expectedRoles: ['USER'] }
  },
  {
    path: 'jobs/view-all-jobs',
    component: ViewAllJobsComponent,
    // canActivate: [authGuard], data: { expectedRoles: ['USER'] }
  },
  {
    path: 'jobs/job-details',
    component: JobDetailsComponent,
    // canActivate: [authGuard], data: { expectedRoles: ['USER'] }
  },
  {
    path: 'jobs/job-apply',
    component: JobApplyComponent,
    // canActivate: [authGuard], data: { expectedRoles: ['USER'] }
  },
  {
    path: 'jobs/job-details/:id',
    component: JobDetailsComponent,
    // canActivate: [authGuard], data: { expectedRoles: ['USER'] }
  },
  {
    path: 'jobs/job-apply/:id',
    component: JobApplyComponent,
    // canActivate: [authGuard], data: { expectedRoles: ['USER'] }
  },
  {
    path: ':name/brand-profile/:id',
    component: BrandProfileComponent
  },
  {
    path: 'hospitals',
    component: HospitalsComponent
  },
  {
    path:'doctors',
    component:HospitalsComponent

  },
  {
    path:'doctor-info/:id',
    component:DocterInfoComponent
  },
  {
    path: ':/hospital-portfolio/:id',
    component: HospitalPortfolioComponent
  },
  {
    path: 'webinars',
    component: WebinarComponent
  },
  {
    path: 'webinars/view/:id',
    component: WebinarViewComponent
  },
  {
    path: 'user/products/productEnquiryDistributors/:id',
    component: ProductEnquiryDistributorsComponent
  },
  {
    path: 'productDistributionRequest/:id',
    component: ProductDistributionRequestComponent
  },
  {
    path: 'hospitalDetails/:id',
    component: HospitalDetailsComponent
  },
  {
    path: 'news',
    component: NewsandTrendsComponent
  },
  {
    path: 'news_insights',
    component: NewsAndInsightsComponent
  },
  {
    path:'labs',
    component:HospitalsComponent

  },
  {
    path:'healthcareServices',
    component:HealthcareServicesComponent
  },
  {
    path: 'labs/:id',
    component:LabInfoComponent
  },
  {
    path: 'clinics',
    component: HospitalsComponent
  },
  {
    path: 'clinics/:id',
    component: ClinicDetailsComponent
  },
  {
    path: 'events',
    component: UnderDevelopmentComponent
  },
  {
    path: 'conferences',
    component: UnderDevelopmentComponent
  },
  {
    path: 'blogs',
    component: UnderDevelopmentComponent
  },
  {
    path: 'magazines',
    component: UnderDevelopmentComponent
  },
  {
    path: 'journals',
    component: UnderDevelopmentComponent
  },
  {
    path: 'home',
    component : EndCustomerComponent
  },
  {
    path: 'products-view',
    component :HomeProductViewComponent
  },
  {
    path: 'knowledge_center',
    component:KnowledgeCenterComponent
  },
  {
    path: 'products-search',
    component: ProductsSearchLandingPageComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AuthenticationRoutingModule { }
